import { useIntl } from 'react-intl';
import type { FormatNumberOptions } from 'react-intl';

import { useFormatPrice } from '@packages/shared/src/hooks/useFormatPrice/useFormatPrice';

type IntegerPrice = number;
type Percentage = number;

type AbsoluteDiscount = {
  // priceDifference must to be in cents, e.g. 1337 for a discount of 13.37 €
  priceDifference: IntegerPrice;
  // currency must be to be a valid ISO 4217 currency code, e.g. 'EUR'
  currency: FormatNumberOptions['currency'];
};

type PercentDiscount = {
  // discountPercentage must be a number, e.g. 13.37 for a discount of 13.37%
  discountPercentage: Percentage;
};

export const useFormatDiscount = () => {
  const { formatPrice } = useFormatPrice();
  const { formatNumber } = useIntl();

  const formatDiscount = (discount: AbsoluteDiscount | PercentDiscount) => {
    if ('priceDifference' in discount) {
      return formatPrice(discount.priceDifference, discount.currency);
    }
    if ('discountPercentage' in discount) {
      return formatNumber(discount.discountPercentage / 100, {
        style: 'percent',
      });
    }

    throw new Error('Invalid discount type');
  };

  return { formatDiscount };
};
